import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import Tooltip from '@mui/material/Tooltip'
import MenuItem from '@mui/material/MenuItem'
import OpacityIcon from '@mui/icons-material/Opacity'
import { useAppDispatch, useAppSelector } from '../../hooks/hooks'
import { logOut } from '../../store/userSlice'
import { useEffect, useState, MouseEvent } from 'react'
import './Header.scss'
import { Link, NavLink } from 'react-router-dom'
import { Divider } from '@mui/material'
import { checkAuth, decodeToken } from '../../services/autorization'
import { resetFilters } from '../../store/filtersSlice'
import Button from '@mui/material/Button'

const Header = () => {
  const { isLogin, id, role, name } = useAppSelector((state) => state.user)
  const appDispatch = useAppDispatch()

  const handleLogOut = () => {
    appDispatch(logOut())
    appDispatch(resetFilters())
    handleCloseNavMenu()
  };

  useEffect(() => {
    if (localStorage.getItem('dataPortal')) {
      //@ts-ignore
      const token = JSON.parse(localStorage.getItem('dataPortal')).token
      const id = decodeToken(token)
      console.log(id)
      appDispatch(checkAuth({ ...id, token }))
    }
  }, [])

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)

  const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }
  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const handleHomeClick = () => {
    window.location.href = 'https://www.gorvodokanal.com/'
  }

  return (
    <header className="header">
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <button
              onClick={handleHomeClick}
              style={{
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                padding: 0,
                display: 'flex',
                alignItems: 'center',
              }}
              aria-label="Home"
            >
              <OpacityIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, color: 'white' }} />
            </button>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                <MenuItem onClick={handleCloseNavMenu} component={Link} to="main">
                  <Typography textAlign="center">Обращения</Typography>
                </MenuItem>
                {role === '1' && (
                  <MenuItem onClick={handleCloseNavMenu} component={Link} to="registration">
                    <Typography textAlign="center">Регистрация</Typography>
                  </MenuItem>
                )}
                {id === '95' && (  
                  <MenuItem onClick={handleCloseNavMenu} component={Link} to="statistics">
                    <Typography textAlign="center">Статистика</Typography>
                  </MenuItem>
                )}
              </Menu>
            </Box>

            <OpacityIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />

            <Typography
              variant="h5"
              noWrap
              component="a"
              href=""
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              Горводоканал
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              <MenuItem component={Link} to="main">
                Обращения 
              </MenuItem>

              {role === '1' && (
                <MenuItem component={Link} to="registration">
                  Регистрация
                </MenuItem>
              )}
              {id === '95' && (     
                <MenuItem component={Link} to="statistics">
                  Статистика
                </MenuItem>
              )}
            </Box>

            <Box
              sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', columnGap: '20px' }}
              className="icojn"
            >
              <Typography className="header-name">{name}</Typography>
              <Tooltip title="Выход">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt={name} src={name} />
                </IconButton>
              </Tooltip>

              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem disabled>
                  <Typography textAlign="center" sx={{ color: 'black' }}>
                    {name}
                  </Typography>
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleLogOut}>
                  <Typography textAlign="center">Выход</Typography>
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </header>
  )
}
export default Header